import React, { Component } from 'react'
import { Doughnut } from 'react-chartjs-2';
import { inject, observer } from 'mobx-react';
import { ethMultiplier } from '../../constants';
import { FaEthereum } from 'react-icons/fa';
import { relative } from 'path';

@observer(["TeamStore"])
class ProviderOdds extends Component {
    render() {
        const { TeamStore } = this.props;
        let colors = [];
        let borderColors = [];
        let totalAmount = 0;
        let button1;
        let button2;
        let donutLabels = this.props.teams.map((team, index) => {
            let thisTeam = TeamStore.teams.get(team);
            // if (index == 0) {
            //     button1 = <button className="custom-btn-primary">BET ON {thisTeam.name}  5.00</button>;
            // }
            // if (index == 1) {
            //     button2 = <button className="custom-btn-primary">BET ON {thisTeam.name}  1.25</button>;
            // }
            colors.push(thisTeam.colors[0]);
            borderColors.push('rgba(0,0,0,0.1)');
            console.log("team colors " + thisTeam.colors[0]);

            return ((this.props.event.amountBetForTeam[index] / ethMultiplier).toFixed(2) + " on " + thisTeam.abbreviation.toUpperCase())
        });

        // (amountBetForTwo / ethMultiplier).toFixed(2) + " on " + this.state.teamTwoAbbreviation.toUpperCase() + "         ",// + " - " + team_two.slice(0, 2),// team_two,
        // //'Draw',
        // (amountBetForOne / ethMultiplier).toFixed(2) + " on " + this.state.teamOneAbbreviation.toUpperCase() + "         ",//team_one,


        // let data = this.props.event.amountBetForTeam.map((amount) => {
        //     totalAmount += amount;
        //     return (amount / ethMultiplier).toFixed(3);
        // });
        let data = this.props.odds;

        if (this.props.event.drawPossible) {
            donutLabels.push((this.props.event.amountBetForDraw / ethMultiplier).toFixed(2) + " on a DRAW");
            totalAmount += this.props.event.amountBetForDraw;
            data.push((this.props.event.amountBetForDraw / ethMultiplier).toFixed(3));
            colors.push("rgb(126,126,126)");
            borderColors.push('rgba(0,0,0,0.1)');
        }

        // if (totalAmount == 0) {
        //     data = [];
        //     this.props.teams.forEach(team => {
        //         data.push(1);
        //     })
        //     if (this.props.event.drawPossible) {
        //         data.push(1);
        //     }
        // }




        const DoughnutData = {
            labels: donutLabels,

            datasets: [{
                data: data,
                backgroundColor: colors,
                hoverBackgroundColor: colors,
                borderColor: borderColors
            }]
        };

        return (
            <div className="space-mono">


                {/* Put Donut chart here */}
                <div style={{ marginTop: '-10px' }}>
                    <Doughnut style={{ position: "relative", top: 0 }}
                        responsive={false}
                        legend={null}
                        height={20}

                        options={{
                            cutoutPercentage: 70,
                            maintainAspectRatio: true,
                            animateRotate: false,
                            animateScale: true,
                            tooltips: {
                                callbacks: {
                                    title: function (tooltipItem, data) {
                                        return data['labels'][tooltipItem[0]['index']];
                                    },
                                    label: function (tooltipItem, data) {
                                        return "";//data['datasets'][0]['data'][tooltipItem['index']];
                                    },
                                    afterLabel: function (tooltipItem, data) {
                                        var dataset = data['datasets'][0];
                                        var percent = (dataset["_meta"][0] !== undefined ? Math.round((dataset['data'][tooltipItem['index']] / dataset["_meta"][0]['total']) * 100) : 0).toFixed(2)
                                        return '(' + percent + '%)';
                                    }
                                }
                            }
                        }}

                        data={DoughnutData}
                    />
                    {/* {button1}
                    {button2} */}
                </div>


            </div>
        )
    }
}
export default ProviderOdds;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/ProviderOdds.js